import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from './../utils';

import {Modal, message} from 'antd';

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = () => {
    return fetch.post('employee/edit', {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}


/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (data) => {
    return fetch.post('employee/modify', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '信息更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动更新页面！</p>
                    </div>
                ),
                okText:"确认",
                onOk() {
                    window.location.hash = 'employee/edit/index';
                },
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const setPassword = (data) => {
    return fetch.post('employee/modify/pwd', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '信息更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动更新页面！</p>
                    </div>
                ),
                okText:"确认",
                onOk() {
                    window.location.hash = 'employee/edit/index';
                },
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
 const setStuPassword = (data) => {
    return fetch.post('student/modify/pwd', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '信息更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动更新页面！</p>
                    </div>
                ),
                okText:"确认",
                onOk: () => {
                    window.location.hash = 'student/pwd/index';
                },
            });
        }
    });
}

export default {
    querySearchById,
    update,
    setPassword,
    setStuPassword
}